// SEC-XSS: JSON-LD is injected into the page via
// `<script type="application/ld+json" dangerouslySetInnerHTML={...}>`. The
// payload is built from DB-derived, attacker-influenceable data (a scraped
// company `name`/`slug`/`description`, a blog `title`/`body`, etc.). Raw
// `JSON.stringify(x)` does NOT escape `<`, `>` or `&`, so a value containing
// `</script><script>...</script>` would terminate the JSON-LD <script>
// element and execute attacker HTML in the document context (stored XSS).
//
// Mitigation: escape the characters that let a string break out of a <script>
// element BEFORE it reaches the DOM. < and > prevent the element from being
// closed; & is defence-in-depth against HTML-entity reinterpretation; U+2028
// and U+2029 are valid in JSON but illegal in JS string literals. All are valid
// JSON escapes, so the structured data a crawler parses is byte-for-byte
// identical — only the in-HTML representation is hardened.
//
// jsonLdProps() returns the { __html } object so call-sites read:
//   <script type="application/ld+json" dangerouslySetInnerHTML={jsonLdProps(x)} />

export function serializeJsonLd(data: unknown): string {
  return JSON.stringify(data)
    .replace(/</g, "\\u003c")
    .replace(/>/g, "\\u003e")
    .replace(/&/g, "\\u0026")
    .replace(/\u2028/g, "\\u2028")
    .replace(/\u2029/g, "\\u2029")
}

export function jsonLdProps(data: unknown): { __html: string } {
  return { __html: serializeJsonLd(data) }
}
